module.exports = __webpack_public_path__ + "media/images/logos/WS_logo_texte_white-72024a77fce339da38ebc859bb37b10d.png";